const BotswanaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110942)">
      <path
        d="M0.944375 13.9125C0.331719 15.832 -7.81112e-05 17.8767 1.37933e-08 19.9995C-7.81112e-05 22.122 0.331719 24.1669 0.944453 26.0864L20 26.9561L39.0555 26.0864C39.668 24.1669 39.9999 22.122 39.9999 19.9995C39.9999 17.8769 39.6681 15.832 39.0555 13.9125L19.9999 13.043L0.944375 13.9125Z"
        fill="#F0F0F0"
      />
      <path
        d="M40 19.9998C40 18.8134 39.8961 17.6512 39.6979 16.5215H0.302188C0.103906 17.6512 0 18.8132 0 19.9998C0 21.1863 0.103984 22.3484 0.302188 23.478H39.6979C39.896 22.3483 40 21.1862 40 19.9998Z"
        fill="black"
      />
      <path
        d="M20.0004 40C28.9235 40 36.4805 34.1561 39.0558 26.0869H0.944824C3.52022 34.156 11.0773 39.9999 20.0004 40Z"
        fill="#338AF3"
      />
      <path
        d="M20.0005 3.13307e-09C11.0774 3.13307e-09 3.52037 5.84398 0.944824 13.9129L39.0558 13.913C36.4805 5.84398 28.9234 -0.000156247 20.0005 3.13307e-09Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110942">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BotswanaSvg;
